import './style.sass';

import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';
class About extends Component {
    render() {
        return (
            <div className="garant-fond-about">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <FullWrapper isMargin={false} caseName="main-title">
                        <div className="garant-fond-about__grid">
                            <CommonUsualText className="garant-fond-about__text">
                                Мы начали сотрудничать с Гарантийным фондом Ростовской области в
                                августе 2022 по направлениям SMM и SEO. Нашей команде были переданы
                                сообщество в социальной сети «ВКонтакте», группа в «Одноклассниках»,
                                телеграмм-канал, который был только что создан, страница «Дзен» и
                                корпоративный сайт.
                            </CommonUsualText>

                            <div className="garant-fond-about-img">
                                <div className="garant-fond-about-img__logo">
                                    <img
                                        src="/images/pic/garant-fond/logo.png"
                                        alt="stages"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-about-img__icons">
                                    <img
                                        src="/images/pic/garant-fond/soc.png"
                                        alt="stages"
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </div>
                    </FullWrapper>
                </ScrollAnimation>
            </div>
        );
    }
}

export default About;
